import { render } from "./UserColumnData.vue?vue&type=template&id=6322e2ad"
import script from "./UserColumnData.vue?vue&type=script&lang=js"
export * from "./UserColumnData.vue?vue&type=script&lang=js"

import "./UserColumnData.vue?vue&type=style&index=0&id=6322e2ad&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__